<template>
    <div class="row justify-content-center">
      <div class="col-lg-12 col-md-7">
        <div class="card bg-secondary shadow-lg border-0">
          <div class="card-body px-lg-5 py-lg-5">
            <div class="col-lg-12">
             
                  <div class="mx-0 mx-sm-3 my-5"> 
                    <div class="d-flex">
                     <i class="fas fa-tools fa-3x mr-5 mt-2 text-gray"></i>
                      <div>
                        <h1>En este momento estamos en Mantenimiento.</h1>
                        <h3 class="font-weight-normal">Si deseas darte de alta como cliente por favor contacta a tu agente de ventas.</h3>
                        <h3 class="mt-4">Disculpa las molestias.</h3>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
    import firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/firestore";
    import Multiselect from "vue-multiselect";


  export default {
    name: 'maintenance',
    data() {
      return {
        
      }
    },
    methods: {
        
    }
  }
</script>
<style>
</style>
